import { NgTemplateOutlet } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { FullProjectHash } from "../../../../_models/project.interface";
import { CreateStatusAttributes } from "../../../../_models/status.interface";
import { ProjectService } from "../../../../_services";
import { FormModalComponent } from "../form-modal-component.class";
import { categoryValue, statusPreviewLabel } from "../status-category-form.helper";

@Component({
  selector: "hawk-edit-status-modal",
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: "./edit-status-modal.component.html",
  standalone: true,
  styleUrls: ["./edit-status-modal.component.scss"],
})
export class EditStatusModalComponent extends FormModalComponent<CreateStatusAttributes, FullProjectHash> {
  @Input() project: FullProjectHash;

  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<FullProjectHash> = new EventEmitter<FullProjectHash>();

  constructor(private projectService: ProjectService) {
    super();
  }

  override formGroupToDBInput(): CreateStatusAttributes {
    return {
      id: this.formGroup.controls["id"].value,
      main_category: categoryValue(this.formGroup.controls["main_category"].value),
      sub_category: categoryValue(this.formGroup.controls["sub_category"].value),
      title: this.formGroup.controls["name"].value,
      closed: this.formGroup.controls["closed"].value,
      report_closed: this.formGroup.controls["report_closed"].value,
      canceled: this.formGroup.controls["canceled"].value,
      color: this.formGroup.controls["color"].value,
      email: this.formGroup.controls["email"].value,
      fixer_forbidden: this.formGroup.controls["fixer_forbidden"].value,
      visible_app: this.formGroup.controls["visible_app"].value,
      fallback_status: this.formGroup.controls["fallback_status"].value,
      unplanned: this.formGroup.controls["unplanned"].value,
      project_id: this.formGroup.controls["project_id"].value,
      mail_template_id: this.formGroup.controls["mail_template_id"].value,
      task_ids: this.formGroup.controls["task_ids"].value,
    };
  }

  // Vorschau des Anzeigenamens ("3.0 erledigt") aus den Formularfeldern
  previewLabel(): string {
    return statusPreviewLabel(this.formGroup.getRawValue());
  }

  override getDBCallObservable(create_status_attributes: CreateStatusAttributes): Observable<FullProjectHash> {
    return this.projectService.updateProjectStatus(
      create_status_attributes.project_id,
      create_status_attributes.id,
      create_status_attributes,
    );
  }
}
